import "./TrueTrack.css";
import heroPhone from "../../assets/tt-section.png";
import ttSection2 from "../../assets/tt-section2.png";
import ttWhyImg from "../../assets/tt-section3.png";
import truerenewableslogo from "../../assets/truerenewables_logo.svg";
import heroPhoneMobile from "../../assets/tt-section1.png";

import ttCap1 from "../../assets/tt-cap1.png";
import ttCap2 from "../../assets/tt-cap2.png";
import ttCap3 from "../../assets/tt-cap3.png";
import ttCap4 from "../../assets/tt-cap4.png";
import ttCap5 from "../../assets/tt-cap5.png";
import ttCap6 from "../../assets/tt-cap6.png";
import ttSection7Img from "../../assets/tt-section7.png";
import trackBenefits1 from "../../assets/truetrack-benefits 1.png";
import trackBenefits2 from "../../assets/tretrack-benefits 2.png";
import trackBenefits3 from "../../assets/truetrack-benefits 3.png";
import trackBenefits4 from "../../assets/truetrack-benefits-4.png";
import trackBenefits5 from "../../assets/truetrack-benefits-5.png";
import ttAdv1 from "../../assets/tt-adv1.png";
import ttAdv2 from "../../assets/tt-adv2.png";
import ttAdv3 from "../../assets/tt-adv3.png";
import ttAdv4 from "../../assets/tt-adv4.png";
import ttSection9Img from "../../assets/trutracknextgeneration.png";
import ecoBg from "../../assets/eco-bg.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// ADD THIS BLOCK:
const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };
    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ================================================
   SECTION 1 — HERO
   ================================================ */
const TrueTrackHero = () => {
  const navigate = useNavigate();
  return (
    <section
      className="tt-hero-section"
      style={{ "--eco-bg": `url(${ecoBg})` }}
    >
      <div className="tt-hero-container">
        <div className="tt-hero-left">
          <h1 className="tt-hero-title">
            Real-Time Visibility. Zero Delays. Total Control.
          </h1>
          <p className="tt-hero-desc">
            TrueTrack™ is a new-generation EPC intelligence platform built to
            deliver transparent, predictable and data-driven solar execution —
            from Day 1 of planning to final commissioning.
          </p>
          <button className="tt-hero-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
        </div>

        <div className="tt-hero-right">
          {/* Add image here once tt-section1.png is exported from Figma */}
          <picture>
            {/* Mobile image */}
            <source media="(max-width: 767px)" srcSet={heroPhoneMobile} />

            {/* Desktop + Tablet image */}
            <img
              src={heroPhone}
              alt="TrueTrack Hero"
              className="tt-hero-phone"
            />
          </picture>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 2 — WHAT IS TRUETRACK
   ================================================ */
const checkItems = [
  "Real-time project tracking",
  "Daily site reporting",
  "Milestone-based timelines",
  "Material movement visibility",
  "Quality checklists",
  "Delay alerts and escalation",
  "Digital documentation",
];

const TrueTrackAbout = () => {
  const rightRef = useReveal();

  return (
    <section className="tt-about-section">
      <div className="tt-about-left">
        <img
          src={ttSection2}
          alt="TrueTrack Dashboard"
          className="tt-about-img"
          loading="lazy"
        />
      </div>

      <div className="tt-about-right reveal-block" ref={rightRef}>
        <p className="tt-about-heading">
          TrueTrack™ is True Renewables' proprietary EPC digital execution
          engine that monitors, manages and reports every step of your solar
          installation with:
        </p>
        <p className="tt-about-sub">
          Where most EPCs stop at installation, we go 10 layers deeper:
        </p>
        <ul className="tt-about-list">
          {checkItems.map((item) => (
            <li key={item} className="tt-about-list-item">
              <svg
                className="tt-check-icon"
                width="16"
                height="13"
                viewBox="0 0 16 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 6L6 11L15 1"
                  stroke="#C04820"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {item}
            </li>
          ))}
        </ul>
        <p className="tt-about-footer">
          It ensures that every EPC project follows a structured, transparent,
          and intelligent execution flow.
        </p>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — WHY TRUETRACK EXISTS
   ================================================ */
const ttLeftCards = [
  { num: "01", text: "Lack of clarity" },
  { num: "02", text: "No visibility" },
  { num: "03", text: "No documentation" },
];
const ttRightCards = [
  { num: "04", text: "No accountability" },
  { num: "05", text: "Unpredictable timelines" },
  { num: "06", text: "Untracked material delays" },
];

const TrueTrackWhyExists = () => {
  const headerRef = useReveal();

  return (
    <section className="tt-why">
      <div className="tt-why-header reveal-block" ref={headerRef}>
        <p className="tt-why-tag">
          <span className="tt-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="tt-why-title">Why TrueTrack™ Exists</h2>
        <p className="tt-why-subtitle">
          Most EPC execution problems come from:
        </p>
      </div>

      <div className="tt-why-body">
        <div className="tt-why-col">
          {ttLeftCards.map((c) => (
            <div className="tt-why-card" key={c.num}>
              <p className="tt-why-num">{c.num}</p>
              <p className="tt-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="tt-why-img-wrap">
          <img
            src={ttWhyImg}
            alt="Why TrueTrack Exists"
            className="tt-why-img"
            loading="lazy"
          />
        </div>

        <div className="tt-why-col">
          {ttRightCards.map((c) => (
            <div className="tt-why-card" key={c.num}>
              <p className="tt-why-num">{c.num}</p>
              <p className="tt-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — SINGLE WINDOW OF TRUTH
   ================================================ */
const leftRow1 = ["Project Owners", "Government Clients", "Site Engineers"];
const leftRow2 = ["Management Teams", "EPC Contractors", "Field Teams"];
const rightRow1 = ["Industrial Clients", "Project Managers", "Investors"];
const rightRow2 = ["Industries", "Farmers", "Government Bodies"];

const TrueTrackSingleWindow = () => {
  const headerRef = useReveal();

  return (
    <section className="tt-sw-section">
      <p className="tt-sw-title reveal-block" ref={headerRef}>
        TrueTrack™ solves every one of these challenges
        <br />
        by creating a single window of truth for:
      </p>

      <div className="tt-sw-orbit">
        {/* Left pills — scroll rightward toward center */}
        <div className="tt-sw-side tt-sw-side--left">
          <div className="tt-sw-row">
            <div className="tt-pills-track tt-pills-track--right">
              {[...leftRow1, ...leftRow1].map((label, i) => (
                <span className="tt-pill" key={`lr1-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
          <div className="tt-sw-row">
            <div className="tt-pills-track tt-pills-track--right tt-pills-track--delay">
              {[...leftRow2, ...leftRow2].map((label, i) => (
                <span className="tt-pill" key={`lr2-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Center logo card */}
        <div className="tt-sw-center">
          <div className="tt-sw-logo-card">
            <img
              src={truerenewableslogo}
              alt="True Renewables"
              className="tt-sw-logo"
              loading="lazy"
            />
          </div>
        </div>

        {/* Right pills — scroll leftward toward center */}
        <div className="tt-sw-side tt-sw-side--right">
          <div className="tt-sw-row">
            <div className="tt-pills-track tt-pills-track--left">
              {[...rightRow1, ...rightRow1].map((label, i) => (
                <span className="tt-pill" key={`rr1-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
          <div className="tt-sw-row">
            <div className="tt-pills-track tt-pills-track--left tt-pills-track--delay">
              {[...rightRow2, ...rightRow2].map((label, i) => (
                <span className="tt-pill" key={`rr2-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <p className="tt-sw-footer">
        You see everything.
        <br />
        Nothing is <strong>hidden</strong>. Nothing is <strong>delayed</strong>.
        Nothing is <strong>lost</strong>.
      </p>
    </section>
  );
};

/* ================================================
   SECTION 5 — KEY CAPABILITIES
   ================================================ */
const capabilities = [
  { icon: ttCap1, label: "Real-Time Project\nDashboard" },
  { icon: ttCap2, label: "Daily Site Reports\n(Photos, Videos, Logs)" },
  { icon: ttCap3, label: "Material Tracking &\nLogistics Monitoring" },
  { icon: ttCap4, label: "Milestone-Based\nTimeline Control" },
  { icon: ttCap5, label: "Approval & Compliance\nStatus" },
  { icon: ttCap6, label: "Analytics & Delay\nAlerts" },
];

const TrueTrackCapabilities = () => {
  const headerRef = useReveal();

  return (
    <section className="tt-cap-section">
      <div className="tt-cap-header reveal-block" ref={headerRef}>
        <p className="tt-cap-tag">
          <span className="tt-cap-dot" />
          CORE FEATURES
        </p>
        <h2 className="tt-cap-title">Key Capabilities of TrueTrack™</h2>
      </div>

      <div className="tt-cap-grid">
        {capabilities.map((cap, i) => (
          <div className="tt-cap-item" key={i}>
            <img src={cap.icon} alt={cap.label} className="tt-cap-icon" loading="lazy" />
            <p className="tt-cap-label">{cap.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ================================================
   SECTION 6 — WORKFLOW STRUCTURE
   ================================================ */
const workflowSteps = [
  {
    num: 1,
    title: "Project Kickoff & Digital Setup",
    desc: "Your project receives a dedicated digital workspace.",
  },
  {
    num: 2,
    title: "Daily Execution Logs",
    desc: "Site team updates progress live.",
  },
  {
    num: 3,
    title: "Digital QC & Engineering Checklists",
    desc: "Standardized quality protocols.",
  },
  {
    num: 4,
    title: "Live Milestone Tracking",
    desc: "Automated % progress updates.",
  },
  {
    num: 5,
    title: "Client Dashboard Access",
    desc: "You view everything in real-time.",
  },
  {
    num: 6,
    title: "Automated Reporting",
    desc: "Weekly + monthly performance reports.",
  },
  {
    num: 7,
    title: "Predictive Delay Alerts",
    desc: "AI predicts possible delays using patterns.",
  },
  {
    num: 8,
    title: "Final Handover Package",
    desc: "Digital document vault delivered at commissioning.",
  },
];

const TrueTrackWorkflow = () => {
  const sectionRef = useRef(null);
  const stepRefs = useRef([]);
  const lineRef = useRef(null);
  const leftRef = useReveal();
  const [activeStep, setActiveStep] = useState(1);

  // REPLACE the entire useEffect scroll handler:
  useEffect(() => {
    const onScroll = () => {
      const section = sectionRef.current;
      const line = lineRef.current;
      if (!section || !line) return;

      const rect = section.getBoundingClientRect();
      const totalHeight = section.offsetHeight;
      const scrolled = -rect.top + window.innerHeight * 0.3;
      const progress = Math.min(Math.max(scrolled / totalHeight, 0), 1);

      // How many px the orange line has grown
      const lineTrackEl = line.parentElement;
      const lineTrackHeight = lineTrackEl.offsetHeight;
      const lineFilledPx = progress * 1.4 * lineTrackHeight;

      // Grow the line
      line.style.transform = `scaleY(${Math.min(progress * 1.4, 1)})`;

      // Activate each step when the line top + filledPx reaches the circle's center
      let newActive = 0; // step 1 always on
      stepRefs.current.forEach((stepEl, i) => {
        if (!stepEl) return;
        const circleEl = stepEl.querySelector(".tt-wf-circle");
        if (!circleEl) return;

        // Circle center relative to lineTrack top
        const lineTrackTop = lineTrackEl.getBoundingClientRect().top;
        const circleCenterY =
          circleEl.getBoundingClientRect().top + circleEl.offsetHeight / 2;
        const circlePxFromLineTop = circleCenterY - lineTrackTop;

        if (lineFilledPx >= circlePxFromLineTop) {
          newActive = i + 1;
        }
      });

      setActiveStep(newActive);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <section className="tt-wf-section" ref={sectionRef}>
      <div className="tt-wf-container">
        {/* Left */}
        <div className="tt-wf-left reveal-block" ref={leftRef}>
          <p className="tt-wf-tag">
            <span className="tt-wf-dot" />
            HOW IT WORKS
          </p>
          <h2 className="tt-wf-title">TrueTrack™ Workflow Structure</h2>
          <p className="tt-wf-subtitle">
            TrueTrack™ follows a digital-first EPC approach:
          </p>
        </div>

        {/* Right: timeline */}
        <div className="tt-wf-timeline">
          <div className="tt-wf-line-track">
            <div className="tt-wf-line-bg" />
            <div className="tt-wf-line-fill" ref={lineRef} />
          </div>

          {workflowSteps.map((step, i) => {
            const isActive = i + 1 <= activeStep;
            return (
              <div
                className={`tt-wf-step${isActive ? " tt-wf-step--active" : ""}`}
                key={step.num}
                ref={(el) => (stepRefs.current[i] = el)}
              >
                <div className="tt-wf-circle">
                  <span className="tt-wf-num">{step.num}</span>
                </div>
                <div className="tt-wf-step-content">
                  <p className="tt-wf-step-title">{step.title}</p>
                  <p className="tt-wf-step-desc">{step.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 7 — WHO BENEFITS
   ================================================ */
const benefitItems = [
  {
    title: "Industrial & Corporate Clients",
    desc: "Complete clarity over execution of captive, group captive and rooftop plants.",
    img: trackBenefits1,
  },
  {
    title: "Government & DISCOM",
    desc: "PM-KUSUM, PM Surya Ghar and feeder solarization projects with accountability.",
    img: trackBenefits2,
  },
  {
    title: "Residential Clients",
    desc: "Fast, transparent rooftop installations.",
    img: trackBenefits3,
  },
  {
    title: "Investors",
    desc: "Progress visibility for multi-MW assets.",
    img: trackBenefits4,
  },
  {
    title: "Internal Teams",
    desc: "Structured workflows for engineering, procurement and site execution.",
    img: trackBenefits5,
  },
];

const TrueTrackBenefits = () => {
  const headerRef = useReveal();
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          benefitItems.length - 1,
          Math.floor(p * benefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="tt-ben-outer"
      ref={outerRef}
      style={{ height: `${benefitItems.length * 110}vh` }}
    >
      <section className="tt-ben-sticky">
        <div className="tt-ben">
          <div className="tt-ben-header reveal-block" ref={headerRef}>
            <p className="tt-ben-tag">
              <span className="tt-ben-dot" />
              OVERALL BENEFITS
            </p>
            <h2 className="tt-ben-title">Who Benefits From TrueTrack™?</h2>
          </div>

          <div className="tt-ben-body">
            <div className="tt-ben-list">

              {benefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`tt-ben-item ${i === activeIndex ? "tt-ben-item--active" : ""}`}
                    onClick={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="tt-ben-bar" />}

                    <div className="tt-ben-text">
                      <p className="tt-ben-item-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && item.desc && (
                        <p className="tt-ben-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="tt-ben-mobile-img-wrap">
                    <div className="tt-ben-mobile-img-bg" />
                    <img
                      src={item.img}
                      alt={item.title}
                      className="tt-ben-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < benefitItems.length - 1 && (
                    <hr className="tt-ben-divider" />
                  )}
                </div>
              ))}
            </div>

            {/* Desktop image */}
            <div className="tt-ben-img-wrap tt-ben-img-wrap--desktop">
              <div className="tt-ben-img-bg" />
              <img
                src={benefitItems[activeIndex].img}
                alt="Who Benefits From TrueTrack"
                className="tt-ben-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION 8 — WHY TRUETRACK MAKES US DIFFERENT
   ================================================ */
const advCards = [
  {
    icon: ttAdv1,
    text: (
      <>
        We don't hide delays — we <strong>FIX</strong> them
      </>
    ),
  },
  {
    icon: ttAdv2,
    text: (
      <>
        We don't depend on WhatsApp groups — we <strong>AUTOMATE</strong> the
        process.
      </>
    ),
  },
  {
    icon: ttAdv3,
    text: (
      <>
        We don't leave clients confused — we give them absolute{" "}
        <strong>CLARITY</strong>
      </>
    ),
  },
  {
    icon: ttAdv4,
    text: (
      <>
        We don't believe in manual tracking — we use <strong>AI-DRIVEN</strong>{" "}
        transparency
      </>
    ),
  },
];

const TrueTrackAdvantages = () => {
  const headerRef = useReveal();

  return (
    <section className="tt-adv">
      <div className="tt-adv-header reveal-block" ref={headerRef}>
        <p className="tt-adv-tag">
          <span className="tt-adv-dot" />
          TRUETRACK ADVANTAGES
        </p>
        <h2 className="tt-adv-title">
          Why TrueTrack™ Makes True Renewables Different
        </h2>
      </div>

      <div className="tt-adv-cards">
        {advCards.map((c, i) => (
          <div className="tt-adv-card" key={i}>
            <div className="tt-adv-icon">
              <img src={c.icon} alt="" width="48" height="48" loading="lazy" />
            </div>
            <p className="tt-adv-card-text">{c.text}</p>
          </div>
        ))}
      </div>

      <p className="tt-adv-footer">
        This is why True Renewables delivers predictable, professional and
        premium-quality EPC, system after system.
      </p>
    </section>
  );
};

/* ================================================
   SECTION 9 — THE FUTURE OF EPC EXECUTION
   ================================================ */
const futureItems = [
  "AI-based delay prediction",
  "Drone imaging integration",
  "Automated quality scoring",
  "Digital twin modeling",
  "Contracted timeline guarantees",
  "Workforce analytics",
  "Smart procurement planning",
];

const TrueTrackFuture = () => {
  const leftRef = useReveal();

  return (
    <section className="tt-future">
      <div className="tt-future-inner">
        <div className="tt-future-left reveal-block" ref={leftRef}>
          <div className="tt-future-header">
            <p className="tt-future-tag">
              <span className="tt-future-dot" />
              NEXT-GENERATION EXECUTION
            </p>
            <h2 className="tt-future-title">The Future Of EPC Execution</h2>
          </div>

          <p className="tt-future-sub">TrueTrack™ is evolving into:</p>

          <ul className="tt-future-list">
            {futureItems.map((item, i) => (
              <li key={i} className="tt-future-list-item">
                <svg
                  className="tt-future-check"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12.5L9.5 18L20 7"
                    stroke="#C04820"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="tt-future-img-wrap">
          <div className="tt-future-img-bg" />
          <img
            src={ttSection9Img}
            alt="Future of EPC Execution"
            className="tt-future-img"
            loading="lazy"
          />
        </div>

        <p className="tt-future-footer">
          We are not building an EPC workflow.
          <br />
          We are building the future of solar execution intelligence in India.
        </p>
      </div>
    </section>
  );
};
/* ================================================
   TRUETRACK PAGE
   ================================================ */
const TrueTrack = () => (
  <>
    <TrueTrackHero />
    <TrueTrackAbout />
    <TrueTrackWhyExists />
    <TrueTrackSingleWindow />
    <TrueTrackCapabilities />
    <TrueTrackWorkflow />
    <TrueTrackBenefits />
    <TrueTrackAdvantages />
    <TrueTrackFuture />
  </>
);

export default TrueTrack;
